const ɵ0 = navigator.language;
export class OnlinecheckModule {
}
export { ɵ0 };
